import { DeliverableDataNucleus } from '~common/model/Deliverable';

export default function DeliverableRenderNucleus({ data }: { data: DeliverableDataNucleus }): JSX.Element {
  return (
    <iframe
      src={data.url}
      allowFullScreen
      allow="xr-spatial-tracking"
      className="w-full h-full overflow-hidden bg-black"
    />
  );
}
